require('./angular.chips');
require('./angular.chips.css');
var MODULE_NAME = 'angular-chips';

angular.module(MODULE_NAME, ['angular-tag']);

module.exports = MODULE_NAME;



// WEBPACK FOOTER //
// ./src/app/common/core/vendor/angular-chips/index.js